import { Component, ViewChild } from '@angular/core';
import {
  DashboardQueryUnbalancedQuantityResultDto,
  DashboardService
} from '@app/api/dmc';
import {TableConfig} from '@shared/interfaces/table/table-config';
import {unbalancedQuantityTable} from '@shared/table-configs/dashboard/unbalanced-quantity.table';
import { HeaderService } from '@app/core/services/header.service';
import { TableComponent } from '@shared/components/table/table.component';
import {HeaderComponent} from '@shared/components/header/header.component';

import {LoadingService} from '@app/core/services/loading.service';
import { Trash } from 'lucide-angular';
import { ModalService } from '@app/core/services/modal.service';
import { DashboardDismissUnbalancedQuantityComponent } from '@shared/modals/dashboard/query/dashboard-dismiss-unbalanced-quantity/dashboard-dismiss-unbalanced-quantity.component';
import { SortParam } from '@app/core/constants/sort-param';

@Component({
  selector: 'app-dashboard-unbalancedquantity',
  imports: [
    HeaderComponent,
    TableComponent
],
  templateUrl: './dashboard-unbalancedquantity.component.html',
  styleUrl: './dashboard-unbalancedquantity.component.css'
})
export class DashboardUnbalancedQuantityComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  public tableData: DashboardQueryUnbalancedQuantityResultDto[] = [];
  public tableConfig: TableConfig<DashboardQueryUnbalancedQuantityResultDto> = {
    ...unbalancedQuantityTable,
    serviceCallback: (pageSize: number, page: number, sort?: SortParam) =>
      this.dashboardService.dashboardQueryUnbalancedQuantityPost({
        page,
        pageSize,
        sortParameters: sort ? [{ sortField: sort.sortField, sortDirection: sort.sortDirection as any }] : null,
      }),
    contextActions: [
      {
        id: 'dismiss',
        title: 'dashboard.query.unbalancedquantity.dismiss',
        icon: Trash,
        callback: () => this.openDismissModal(),
        disabled: () => this.selectedElements.length === 0,
      },
    ],
  };

  public selectedElements: DashboardQueryUnbalancedQuantityResultDto[] = [];

  constructor(
    private readonly headerService: HeaderService,
    private readonly dashboardService: DashboardService,
    private readonly loadingService: LoadingService,
    private readonly modalService: ModalService,
  ) {
    this.headerService.setTitle('dashboard.query.unbalancedquantity.title');
    this.headerService.setActions(
      [{ id: 'dismiss', title: 'dashboard.query.unbalancedquantity.dismiss', icon: Trash }],
      { dismiss: () => this.openDismissModal() },
      { dismiss: () => this.selectedElements.length === 0 },
    );
  }

  private openDismissModal(): void {
    this.modalService.show({
      title: 'dashboard.query.unbalancedquantity.remove.title',
      component: DashboardDismissUnbalancedQuantityComponent,
      type: 'center',
      actions: [
        { type: 'primary', label: 'system.button.ok', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: {
        elements: this.selectedElements,
      },
    }).subscribe(() => {
      this.table?.search();
    });
  }
}
